/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlPaymentsFilters } from './ControlPaymentsFilters';
import {
    ControlPaymentsFiltersFromJSON,
    ControlPaymentsFiltersFromJSONTyped,
    ControlPaymentsFiltersToJSON,
} from './ControlPaymentsFilters';

/**
 * 
 * @export
 * @interface ControlPaymentHistoryRequest
 */
export interface ControlPaymentHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlPaymentHistoryRequest
     */
    user_id?: string;
    /**
     * 
     * @type {ControlPaymentsFilters}
     * @memberof ControlPaymentHistoryRequest
     */
    filters: ControlPaymentsFilters;
}

/**
 * Check if a given object implements the ControlPaymentHistoryRequest interface.
 */
export function instanceOfControlPaymentHistoryRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "filters" in value;

    return isInstance;
}

export function ControlPaymentHistoryRequestFromJSON(json: any): ControlPaymentHistoryRequest {
    return ControlPaymentHistoryRequestFromJSONTyped(json, false);
}

export function ControlPaymentHistoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaymentHistoryRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'filters': ControlPaymentsFiltersFromJSON(json['filters']),
    };
}

export function ControlPaymentHistoryRequestToJSON(value?: ControlPaymentHistoryRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'filters': ControlPaymentsFiltersToJSON(value.filters),
    };
}

